import { AssignedClinicianSection } from './assigned-clinician-section'
import { ReassignmentCardBase } from './base'

interface ReassignmentScheduledCardProps {
  status: 'approved' | 'assigned_to_cc'
  effectiveDate: string
  requesterType: string
  canCancel?: boolean
  onCancelClick?: () => void
  onViewDetailsClick?: () => void
  clinicianName?: string
  clinicianEmail?: string
  onClinicianNameClick?: () => void
  clinicianEmailCopied?: boolean
}

export function ReassignmentScheduledCard({
  status,
  effectiveDate,
  requesterType,
  canCancel = false,
  onCancelClick,
  onViewDetailsClick,
  clinicianName,
  clinicianEmail,
  onClinicianNameClick,
  clinicianEmailCopied = false,
}: ReassignmentScheduledCardProps) {
  const subtitle = `Effective ${effectiveDate} | ${requesterType}`

  // Derive badge from status (same as in-progress)
  const badgeText = status === 'assigned_to_cc' ? 'Assigned to CC' : 'Approved'
  const badgeColor = status === 'assigned_to_cc' ? 'gold' : 'mint'
  const badge = { label: badgeText, color: badgeColor as 'mint' | 'gold' }

  // Show assigned clinician section if we have clinician name
  const showAssignedClinician = !!clinicianName

  const cancelButton =
    canCancel && onCancelClick ? { label: 'Cancel', onClick: onCancelClick } : undefined

  return (
    <ReassignmentCardBase
      title="Reassignment Scheduled"
      subtitle={subtitle}
      badge={badge}
      secondaryActionButton={cancelButton}
      onViewDetailsClick={onViewDetailsClick}
    >
      {/* Assigned Clinician section */}
      {showAssignedClinician && (
        <AssignedClinicianSection
          clinicianName={clinicianName}
          clinicianEmail={clinicianEmail}
          onClinicianNameClick={onClinicianNameClick}
          emailCopied={clinicianEmailCopied}
        />
      )}
    </ReassignmentCardBase>
  )
}
